import React from 'react';
import PropTypes from 'prop-types';
import {compose} from 'recompose';
import {TextField, withStyles} from "@material-ui/core";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import t from "../../languages/pl";
import ActionCreator from './../../store/actions/index';
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";


const useStyles = (theme) => ({

    filterAddressLabel: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1)
    },

    filterAddressRow: {
        display: "flex",
        margin: theme.spacing(1)
    },

    iconButton: {
        minWidth: 30,
    },
});

const FilterAddress = props => {
    const {
        classes, searchField, street, city, postalCode, radius
    } = props;

    const onSearchWithAddressHandler = () => {
        props.getCarsForMap(searchField, {street, city, postalCode, radius});
    };


    return (
        <React.Fragment>
            <div className={classes.filterAddressLabel}>
                {t.searchWithAddress}
            </div>
            <div className={classes.filterAddressRow} style={{gap: 10}}>
                <TextField
                    InputLabelProps={{
                        shrink: true,
                        classes: {root: classes.label}
                    }}
                    label={t.streetHouseNumber}
                    variant="standard"
                    fullWidth
                    size="small"
                    value={street}
                    onChange={(e) => props.setFilterAddressStreetField(e.target.value)}
                />
                <TextField
                    InputLabelProps={{
                        shrink: true,
                        classes: {root: classes.label}
                    }}
                    label={t.city}
                    variant="standard"
                    fullWidth
                    size="small"
                    value={city}
                    onChange={(e) => props.setFilterAddressCityField(e.target.value)}

                />

                <TextField
                    InputLabelProps={{
                        shrink: true,
                        classes: {root: classes.label}
                    }}
                    label={t.zipCode}
                    variant="standard"
                    fullWidth
                    size="small"
                    value={postalCode}
                    onChange={(e) => props.setFilterAddressPostalCodeField(e.target.value)}

                />

                <TextField
                    InputLabelProps={{
                        shrink: true,
                        classes: {root: classes.label}
                    }}
                    type="number"
                    label={t.radiusKm}
                    variant="standard"
                    fullWidth
                    size="small"
                    value={radius}
                    onChange={(e) => props.setFilterAddressRadiusField(e.target.value)}

                />


                <Button
                    className={classes.iconButton}
                    onClick={() => onSearchWithAddressHandler()}
                >
                    <SearchIcon/>
                </Button>

            </div>

        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({

    street: state.filterReducer.street,
    city: state.filterReducer.city,
    postalCode: state.filterReducer.postalCode,
    radius: state.filterReducer.radius,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


FilterAddress.propTypes = {
    classes: PropTypes.object,
    onSearchStart: PropTypes.func,
    //redux
    searchField: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    postalCode: PropTypes.string,
    radius: PropTypes.string,

    setFilterAddressStreetField: PropTypes.func,
    setFilterAddressCityField: PropTypes.func,
    setFilterAddressPostalCodeField: PropTypes.func,
    setFilterAddressRadiusField: PropTypes.func,
    getCarsForMap: PropTypes.func,

};

export default compose(withStyles(useStyles), connect(
    mapStateToProps,
    mapDispatchToProps
))(FilterAddress);
